import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { AppTheme, AppStyles } from '../styles/AppTheme';
import { BaseEntityPage } from '../common/components/BaseEntityPage';

export class DashboardAdmin extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.pageTitle = 'Admin Dashboard'
    this.toFetch = []
  }

  renderCustomReady() {
    const largeTiles = [
      { title: 'Survey', link: '/admin/quiz/q1' },
      { title: 'SUBMITS', link: '/admin/submits' },
      { title: 'SIGNUPS', link: '/admin/consumers' },
    ]
    const smallTiles = [
      { title: 'Intro', link: '/admin/intros' },
      { title: 'Docs', link: '/admin/docs' },
      { title: 'Survey (Test)', link: '/admin/quiz/qt' },
      { title: 'Exports', link: '/admin/exports' },
    ]
    return (
      <div className={css(AppStyles.containerContentCenter)}>
        <h1 className={css(AppStyles.pageTitle)}>Admin dashboard</h1>

        <Grid container spacing={2} className={css(Styles.container)}>
          {largeTiles.map(tile => (
            <Grid key={tile.title} item xs={12} sm={12 / largeTiles.length}>
              <Link to={tile.link} className={css(Styles.link)}>
                <Paper className={css(Styles.tile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Link>
            </Grid>
          ))}

          {smallTiles.map(tile => (
            <Grid key={tile.title} item xs={6} sm={12 / smallTiles.length}>
              <Link to={tile.link} className={css(Styles.link)}>
                <Paper className={css(Styles.smallTile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Link>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  container: {
    textAlign: 'center',
    maxWidth: 900
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 200,

    borderTop: '3px solid ' + AppTheme.secondaryColor,
    minHeight: 80,
    boxShadow: 'none',
    backgroundColor: 'white',
    '@media (max-width: 600px)': {
      minHeight: 60,
    }
  },
  smallTile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 200,

    borderTop: '1px solid ' + AppTheme.secondaryColor,
    minHeight: 60,
    backgroundColor: 'white',
    '@media (max-width: 600px)': {
      minHeight: 40,
    }
  },
  title: {
    fontSize: 16,
    fontWeight: 'normal',
    textTransform: 'uppercase'
  },
  link: {
    textDecoration: 'none',
    color: 'black'
  }
})



// WEBPACK FOOTER //
// ./src/screens/DashboardAdmin.js